import React from 'react';
import { useNavigate } from 'react-router-dom';

const DemoHeader = () => {
  const navigate = useNavigate();

  return (
    <header className="demo-header d-flex justify-content-between align-items-center">
      <img src="/assets/img/glammify-logo.png" alt="Glammify Logo" className="demo-logo" onClick={() => navigate('/')} style={{cursor: 'pointer'}} />
      <button className="new-demo-try-btn d-flex align-items-center justify-content-center">Try Glammify</button>
    </header>
  );
};

export default DemoHeader;
